import * as stylex from '@stylexjs/stylex';
import { typographyDesktop } from './typography.desktop.stylex';
import { typographyMobile } from './typography.mobile.stylex';
const MOB = '@media (min-width: 767px)';
export const typography = stylex.defineVars({
  fontWeighRegular: {
    default: typographyDesktop['fontWeighRegular'],
    [MOB]: typographyMobile['fontWeighRegular'],
  },
  fontWeighDemi: {
    default: typographyDesktop['fontWeighDemi'],
    [MOB]: typographyMobile['fontWeighDemi'],
  },
  fontWeighBold: {
    default: typographyDesktop['fontWeighBold'],
    [MOB]: typographyMobile['fontWeighBold'],
  },
  'fontSizeCaption-3': {
    default: typographyDesktop['fontSizeCaption-3'],
    [MOB]: typographyMobile['fontSizeCaption-3'],
  },
  'fontSizeCaption-2': {
    default: typographyDesktop['fontSizeCaption-2'],
    [MOB]: typographyMobile['fontSizeCaption-2'],
  },
  'fontSizeCaption-1': {
    default: typographyDesktop['fontSizeCaption-1'],
    [MOB]: typographyMobile['fontSizeCaption-1'],
  },
  'fontSizeBody-5': {
    default: typographyDesktop['fontSizeBody-5'],
    [MOB]: typographyMobile['fontSizeBody-5'],
  },
  'fontSizeBody-4': {
    default: typographyDesktop['fontSizeBody-4'],
    [MOB]: typographyMobile['fontSizeBody-4'],
  },
  'fontSizeBody-3': {
    default: typographyDesktop['fontSizeBody-3'],
    [MOB]: typographyMobile['fontSizeBody-3'],
  },
  'fontSizeBody-2': {
    default: typographyDesktop['fontSizeBody-2'],
    [MOB]: typographyMobile['fontSizeBody-2'],
  },
  'fontSizeBody-1': {
    default: typographyDesktop['fontSizeBody-1'],
    [MOB]: typographyMobile['fontSizeBody-1'],
  },
  'fontSizeHeading-4': {
    default: typographyDesktop['fontSizeHeading-4'],
    [MOB]: typographyMobile['fontSizeHeading-4'],
  },
  'fontSizeHeading-3': {
    default: typographyDesktop['fontSizeHeading-3'],
    [MOB]: typographyMobile['fontSizeHeading-3'],
  },
  'fontSizeHeading-2': {
    default: typographyDesktop['fontSizeHeading-2'],
    [MOB]: typographyMobile['fontSizeHeading-2'],
  },
  'fontSizeHeading-1': {
    default: typographyDesktop['fontSizeHeading-1'],
    [MOB]: typographyMobile['fontSizeHeading-1'],
  },
  'fontSizeDisplay-4': {
    default: typographyDesktop['fontSizeDisplay-4'],
    [MOB]: typographyMobile['fontSizeDisplay-4'],
  },
  'fontSizeDisplay-3': {
    default: typographyDesktop['fontSizeDisplay-3'],
    [MOB]: typographyMobile['fontSizeDisplay-3'],
  },
  'fontSizeDisplay-2': {
    default: typographyDesktop['fontSizeDisplay-2'],
    [MOB]: typographyMobile['fontSizeDisplay-2'],
  },
  'fontSizeDisplay-1': {
    default: typographyDesktop['fontSizeDisplay-1'],
    [MOB]: typographyMobile['fontSizeDisplay-1'],
  },
  'lineHeightCaption-2': {
    default: typographyDesktop['lineHeightCaption-2'],
    [MOB]: typographyMobile['lineHeightCaption-2'],
  },
  'lineHeightCaption-1': {
    default: typographyDesktop['lineHeightCaption-1'],
    [MOB]: typographyMobile['lineHeightCaption-1'],
  },
  'lineHeightBody-5': {
    default: typographyDesktop['lineHeightBody-5'],
    [MOB]: typographyMobile['lineHeightBody-5'],
  },
  'lineHeightBody-4': {
    default: typographyDesktop['lineHeightBody-4'],
    [MOB]: typographyMobile['lineHeightBody-4'],
  },
  'lineHeightBody-3': {
    default: typographyDesktop['lineHeightBody-3'],
    [MOB]: typographyMobile['lineHeightBody-3'],
  },
  'lineHeightBody-2': {
    default: typographyDesktop['lineHeightBody-2'],
    [MOB]: typographyMobile['lineHeightBody-2'],
  },
  'lineHeightBody-1': {
    default: typographyDesktop['lineHeightBody-1'],
    [MOB]: typographyMobile['lineHeightBody-1'],
  },
});
